import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GroupApiServiceService } from './group-api-service.service';
import { ConfomerService } from '../../providers/confomer/confomer.service';
import { ToasterService } from '../../providers/toaster/toaster.service';
import { catchError, finalize, forkJoin, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { SelectableStudentListModalComponent } from "../../components/personnel-component/student-components/selectable-student-list-modal/selectable-student-list-modal.component";
import { PaginationComponent } from "../../components/pagination/pagination.component";
import { LoaderComponent } from "../../providers/loader.component";
import debounce from 'lodash/debounce';
import { FilterBaseAccessService } from '../../auth/filterbase-access';
import { Router } from '@angular/router';
@Component({
  selector: 'app-group-list',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule, CommonModule, SelectableStudentListModalComponent, PaginationComponent, LoaderComponent,FormsModule],
  templateUrl: './group-list.component.html',
  styleUrl: './group-list.component.css'
})
export class GroupListComponent {

  private groupNameValidator() {
    const allowedPattern = /^[A-Za-z0-9\-\s&]+$/;

    return (control: any): { [key: string]: any } | null => {
      const rawValue = control.value ?? '';
      const value = String(rawValue);

      // Trim leading/trailing spaces
      const trimmed = value.trim();

      // If it becomes empty after trimming => only spaces
      if (trimmed.length === 0) {
        return { whitespace: true };
      }

      // Ensure length 2..50 after trimming
      if (trimmed.length < 2) {
        return { minlength: { requiredLength: 2, actualLength: trimmed.length } };
      }
      if (trimmed.length > 50) {
        return { maxlength: { requiredLength: 50, actualLength: trimmed.length } };
      }

      // No consecutive multiple spaces (optional)
      if (/ {2,}/.test(trimmed)) {
        return { consecutiveSpaces: true };
      }

      // Allowed chars only
      if (!allowedPattern.test(trimmed)) {
        return { pattern: true };
      }

      // Return null means valid
      return null;
    };
  }
 
  groupForm!: FormGroup;
  groupList:any[] = [];
  isreqSending: boolean = false;
 
  paginationData: any = {}
  currentPage: any
  isFetching: boolean = false;
  @ViewChild('modalGroup') modalGroup!: ElementRef<HTMLDialogElement>;
 
  isStudentSelectModalOpen: boolean = false
  studentSelectdata: number[] = [];
 
  searchStr: string = '';
isviewaccess:boolean=true;
iseditaccess:boolean=true;
isdeleteaccess:boolean=true;
isperformanceaccess:boolean=true;
ischatstudentaccess:boolean=true;
isassignaccess:boolean=true;
iscreateaccess:boolean=true;
isgroupviewaccess:boolean=true;
  constructor( access:FilterBaseAccessService,private fb: FormBuilder, private groupApiService: GroupApiServiceService, private comformDialog: ConfomerService, private toasterService: ToasterService, private store: Store, private router: Router) {
    this.groupForm = this.fb.group({
      id: [''],
      group_name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), this.groupNameValidator()]],
    })
    this.isgroupviewaccess=access.checkaccessforfiltersandactions("group");
    this.iscreateaccess=access.checkaccessforfiltersandactions("create group");
    this.isviewaccess=access.checkaccessforfiltersandactions("view group");
    this.iseditaccess=access.checkaccessforfiltersandactions("edit group");
    this.isdeleteaccess=access.checkaccessforfiltersandactions("delete group");
    this.isperformanceaccess=access.checkaccessforfiltersandactions("group performance");
    this.ischatstudentaccess=access.checkaccessforfiltersandactions("group chat student");
    this.isassignaccess=access.checkaccessforfiltersandactions("assign group");
  }
 
 
  ngOnInit(): void {
    this.getData();
  }
 
  getData() {
    this.isFetching = true;
    this.groupList = [];
    this.groupApiService.getGroupList(this.currentPage,this.searchStr)
    .pipe(finalize(() => {
      this.isFetching = false;
    }))
    .subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.groupList = res.data ?? [];
          this.paginationData = res?.pagination ?? {};
          this.updateGroupStudentCounts();
        }
      }, error: (err) => {
        console.error('HTTP error:', err);
      }
    }
    );
  }
 
  get hasData$(): boolean {
    return this.groupList && this.groupList.length > 0;
  }
 
  updateGroupStudentCounts() {
    if (!this.groupList.length) {
      return;
    }
 
    const countRequests = this.groupList.map((group: any) =>
      this.groupApiService.getGroupInsight(group.id).pipe(
        catchError(() => of(null))
      )
    );
 
    forkJoin(countRequests).subscribe((responses: any[]) => {
      this.groupList = this.groupList.map((group: any, index: number) => {
        const responseData = responses[index]?.data;
        const students = responseData?.students ?? responses[index]?.students;
        const studentCount = responseData?.student_count ?? responseData?.students_count ?? responses[index]?.student_count;
 
        return {
          ...group,
          student_count: Array.isArray(students) ? students.length : studentCount ?? group.student_count
        };
      });
    });
  }
 
 
  search = debounce(() => {
    this.getData();
    return;
  }, 500);
 
  onSubmit() {
    if (this.groupForm.invalid) {
      this.groupForm.markAllAsTouched();
      return;
    }
    let data = this.groupForm.value;
    let id = data.id;
    this.isreqSending = true;
    if (id) {
      delete data.id;
      this.groupApiService.updateGroup(data, id).pipe(finalize(() => { this.isreqSending = false; })).subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            this.getData();
            this.closeGroupModal();
            this.toasterService.setToaster('success', 'Group Updated', res.message || 'Group updated successfully');
          }
        }, error: (err) => {
          console.error('HTTP error:', err);
        }
      })
    } else {
      delete data.id;
      this.groupApiService.addGroup(data).pipe(finalize(() => { this.isreqSending = false; })).subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            this.getData();
            this.closeGroupModal();
            this.toasterService.setToaster('success', 'Group Added', res.message || 'Group added successfully');
          }
        }, error: (err) => {
          console.error('HTTP error:', err);
        }
      })
    }
  }
 
  async deleteGroup(id: number | string) {
    const confirmation = this.comformDialog.Open('Confirm Delete', 'Are you sure you want to delete this group?');
    if (await confirmation) {
      this.groupApiService.deleteGroup(id).subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            this.toasterService.setToaster('success', 'Group Deleted', res.message || 'Group deleted successfully');
            this.getData();
          }
        }, error: (err) => {
          console.error('HTTP error:', err);
        }
      })
    }
  }
 
  openGroupModal(data?: any) {
    this.groupForm.reset();
    if (data) {
      this.groupForm.patchValue({
        id: data.id,
        group_name: data.group_name,
      });
    }
    this.modalGroup.nativeElement.showModal();
  }
 
  closeGroupModal() {
    this.groupForm.reset();
    this.modalGroup.nativeElement.close();
  }
 
 
  openAddStudentModal(i: any) {
    this.isStudentSelectModalOpen = true;
    this.studentSelectdata = i
  }
 
  closedModal(e: Event) {
    this.isStudentSelectModalOpen = false;
    if(!this.isStudentSelectModalOpen){
      this.getData();
    }
    this.studentSelectdata = []
  }
 
 
  pageChange(e: any) {
    this.currentPage = e;
    this.getData();
  }
 
  openPerformance(id: number | string) {
    this.router.navigate(['/performance', 'group', id]);
  }
 
  openChat(id: number | string) {
    this.router.navigate(['/messages/create'], {
      queryParams: { group_id: id, type: 'group' },
    });
  }

 
}